module.exports = __webpack_public_path__ + "assets/img/be27638.aab8da6f.svg";